import { create } from 'zustand'

interface UiState {
  sidebarCollapsed: boolean
  mobileSidebarOpen: boolean
  activeTab: string
  toggleSidebar: () => void
  setMobileSidebarOpen: (open: boolean) => void
  setActiveTab: (tab: string) => void
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  mobileSidebarOpen: false,
  activeTab: 'agents',
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setMobileSidebarOpen: (open) => set({ mobileSidebarOpen: open }),
  setActiveTab: (tab) => set({ activeTab: tab }),
}))
